import { AnnotationComponentProps } from "@routes/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentUnderline({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <u>{children}</u>;
}
